import { Trans, useTranslation } from 'next-i18next'

import MultgameBackground from '~/assets/multgame/multgame-background-star-sky'
import { getServerlessImageHandlerUrl } from '~/components/Image/helpers'
import { useAppSelector } from '~/redux/hooks'
import { isAuthenticated } from '~/auth/slices/auth.slice'
import {
  TAG_STATISTICS,
  TAG_ADDITION,
  TAG_DIVISION,
  TAG_FRACTION,
  TAG_GEOMETRY,
  TAG_MULT,
  TAG_NEW,
  TAG_NUMBERS_AND_QUANTITIES,
} from '~/games/constants/games.const'
import { GameCard } from '~/games/components/GameCard'
import ROUTES from '~/shared/constants/routes.const'

export function Games(): React.ReactElement {
  const { t } = useTranslation('games')
  const authenticated = useAppSelector(isAuthenticated)
  const stacknLoadLogoBg = getServerlessImageHandlerUrl({
    key: 'logos/stackn-load-bg-dark.png',
    edits: {
      resize: {
        fit: 'cover',
        width: 2000,
      },
    },
  })

  const treasureTrailLogoBg = getServerlessImageHandlerUrl({
    key: 'gamification/pathToTreasure/TreasureTrailBG.jpg',
    edits: {
      resize: {
        fit: 'cover',
        width: 2000,
      },
    },
  })
  const juniorMathLogoBg = getServerlessImageHandlerUrl({
    key: 'Math Vault/images/math-vault-bg.svg',
    edits: {
      resize: {
        fit: 'cover',
        width: 2000,
      },
    },
  })

  const windSurferLogoBg = getServerlessImageHandlerUrl({
    key: 'gamification/windSurfer/WS_backround_200.png',
    edits: {
      resize: {
        fit: 'cover',
        width: 2000,
      },
    },
  })

  return (
    <div className="min-h-screen bg-no-repeat bg-right-bottom py-8 px-4 lg:px-8 sm:px-16 bg-62.5%">
      <h1 className="mb-8 text-h3 lg:text-h1 text-white w-full text-center">{t('title')}</h1>
      <section className="flex w-11/12 md:w-4/5 max-w-302 gap-6 flex-wrap justify-center m-auto">
        <div className="flex">
          <GameCard
            backgroundPosition="right"
            backgroundUrl={treasureTrailLogoBg}
            from="treasure-trail"
            gameEndpoint={authenticated ? ROUTES.TREASURETRAIL : ROUTES.TREASURETRAIL_LOGIN}
            height={165}
            ingress={Trans({
              t,
              i18nKey: 'treasureTrail.ingress',
              components: { strong: <span className="font-bold" /> },
              children: t('treasureTrail.ingress'),
            })}
            logo="gamification/pathToTreasure/Treasure Trail Logo.png"
            tags={[TAG_ADDITION, TAG_NEW]}
            title={t('treasureTrail.gameTitle')}
            width={176}
          />
        </div>
        <div className="flex">
          <GameCard
            backgroundPosition="center"
            backgroundUrl={windSurferLogoBg}
            from="windsurfer"
            gameEndpoint={authenticated ? ROUTES.WINDSURFER : ROUTES.WINDSURFER_LOGIN}
            height={126}
            ingress={Trans({
              t,
              i18nKey: 'windSurfer.ingress',
              components: { strong: <span className="font-bold" /> },
              children: t('windSurfer.ingress'),
            })}
            logo="gamification/windSurfer/WindSurfer_Logo.png"
            tags={[TAG_DIVISION, TAG_NEW]}
            title={t('windSurfer.gameTitle')}
            width={176}
          />
        </div>
        <div className="flex">
          <GameCard
            backgroundUrl={MultgameBackground}
            from="multgame"
            gameEndpoint={authenticated ? ROUTES.MULT_GAME : ROUTES.MULT_GAME_LOGIN}
            height={176}
            ingress={Trans({
              t,
              i18nKey: 'multMaster.ingress',
              components: { strong: <span className="font-bold" /> },
              children: t('multMaster.ingress'),
            })}
            logo="logos/mult-master-logo.png"
            tags={[TAG_MULT]}
            title={t('multMaster.title')}
            width={176}
          />
        </div>
        <div className="flex">
          <GameCard
            backgroundUrl={stacknLoadLogoBg}
            from="stacknload"
            gameEndpoint={authenticated ? ROUTES.STACKNLOAD : ROUTES.STACKNLOAD_LOGIN}
            height={192}
            ingress={Trans({
              t,
              i18nKey: 'cranegame.ingress',
              components: { strong: <span className="font-bold" /> },
              children: t('cranegame.ingress'),
            })}
            logo="logos/stackn-load-logo.png"
            tags={[TAG_FRACTION]}
            title={t('cranegame.gameTitle')}
            width={176}
          />
        </div>
        <div className="flex">
          <GameCard
            backgroundPosition="center"
            backgroundUrl={juniorMathLogoBg}
            className="px-0"
            from="juniorMath"
            gameEndpoint={authenticated ? ROUTES.MATH_VAULT : ROUTES.JUNIOR_MATH_LOGIN}
            height={340}
            ingress={Trans({
              t,
              i18nKey: 'juniorMath.ingress',
              components: { strong: <span className="font-bold" /> },
              children: t('juniorMath.ingress'),
            })}
            logo="gamification/JuniorMath/JunionMathIconLG.png"
            tags={[TAG_NUMBERS_AND_QUANTITIES, TAG_GEOMETRY, TAG_STATISTICS]}
            title={t('juniorMath.gameTitle')}
            width={250}
          />
        </div>
      </section>
    </div>
  )
}
